import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useState} from 'react';
import {Filter} from '~/GalleryPB/Filter';
import {Typography} from '~library/atoms/Typography';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {Accordion, resizeAccordion} from '~library/molecules/Accordion';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const FilterGroups = ({filters, onFilterToggle, onPremiumInfoClick}) => {
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);

  if (!filters || Object.keys(filters).length === 0) return null;

  return (
    <div className="gallery__filter-groups">
      {largeScreens && (
        <Typography className="gallery__filter__heading--desktop" variant="paragraph2">
          Filter by:
        </Typography>
      )}
      {Object.entries(filters).map(([groupKey, filterGroup]) => {
        const isColorFilter = filterGroup.display_name.toLowerCase() === 'color';
        const accordionBodyWrapperId = `accordionBodyWrapper_${groupKey}`;
        if (Object.keys(filterGroup.filters).length === 0) return null;
        return (
          <FilterGroup
            key={groupKey}
            groupKey={groupKey}
            filterGroup={filterGroup}
            isColorFilter={isColorFilter}
            onFilterToggle={onFilterToggle}
            accordionBodyWrapperId={accordionBodyWrapperId}
            onPremiumInfoClick={onPremiumInfoClick}
          />
        );
      })}
    </div>
  );
};

FilterGroups.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilterToggle: PropTypes.func,
  onPremiumInfoClick: PropTypes.func,
};

const FilterGroup = ({
  groupKey,
  filterGroup,
  isColorFilter,
  accordionBodyWrapperId,
  onFilterToggle,
  onPremiumInfoClick,
}) => {
  const DEFAULT_NUM_FILTERS_TO_SHOW = 8;
  const [seeMore, setSeeMore] = useState(false);
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);

  const renderFilters = (id, filterObj, isColor) =>
    Object.entries(filterObj).map(([k, attributes], i) => {
      const {display_name: filterDisplayName, ...otherAttributes} = attributes;

      if (!seeMore && i >= DEFAULT_NUM_FILTERS_TO_SHOW && !isColor) return null;
      return (
        <Filter
          filterSectionName={id}
          filterId={k}
          filterName={filterDisplayName}
          attributes={otherAttributes}
          isColorFilter={isColor}
          id={k}
          key={`filter--${id}-${i.toString()}-${k}`}
          onToggle={onFilterToggle}
          onPremiumInfoClick={onPremiumInfoClick}
        />
      );
    });
  return (
    <Accordion
      label={filterGroup.display_name}
      key={groupKey}
      alwaysOpen={groupKey === 'free_premium'}
      uniqueAccordionBodyWrapperId={accordionBodyWrapperId}
      onClose={() => setSeeMore(false)}
    >
      <ul
        className={`gallery__filter-list gallery__filter-list__${
          isColorFilter ? 'color' : 'checkbox'
        } gallery__filter-${groupKey} ${groupKey === 'free_premium' && !largeScreens ? 'row' : ''}`}
      >
        {renderFilters(groupKey, filterGroup.filters, isColorFilter)}
      </ul>
      {Object.keys(filterGroup.filters).length > DEFAULT_NUM_FILTERS_TO_SHOW && !isColorFilter && (
        <button
          onClick={() => {
            resizeAccordion(accordionBodyWrapperId);
            setSeeMore(!seeMore);
          }}
          className="unstyled-button paragraph3 subcategory__label subcategory__see-more-btn"
          data-qa-id={`gallery_filterGroup_${groupKey}_ShowMoreButton`}
          style={{marginBottom: '1rem'}}
          type="button"
        >
          See {seeMore ? 'less' : 'more'}
        </button>
      )}
    </Accordion>
  );
};

FilterGroup.propTypes = {
  groupKey: PropTypes.string.isRequired,
  filterGroup: PropTypes.object.isRequired,
  isColorFilter: PropTypes.bool,
  accordionBodyWrapperId: PropTypes.string.isRequired,
  onFilterToggle: PropTypes.func,
  onPremiumInfoClick: PropTypes.func,
};
